import { API } from '@/shared/api/modules';
import type { GetAmenitiesByIdRequestDto } from '@/shared/api/modules/amenities';
import { queryOptions } from '@tanstack/react-query';
import { transformAmenityDtoToAmenity } from './lib';

export const getAmenitiesByIdQueryOptions = (
  params = {} as GetAmenitiesByIdRequestDto
) =>
  queryOptions({
    queryKey: ['amenities', params],
    queryFn: async ({ signal }) => {
      const response = await API.amenities.getAmenitiesById(params, { signal });

      return response.map(({ category, amenities }) => ({
        category,
        amenities: amenities.map(transformAmenityDtoToAmenity),
      }));
    },
  });
